<template>
	<div class="patient-new-appointment">
		<Breadcrumbs :items="items" />
		<v-container fluid>
			<NewAppointmentForm :patients="[patient]" />
		</v-container>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NewAppointmentForm from "@/components/appointment/NewAppointmentForm.vue";

export default {
	name: "PatientNewAppointment",
	props: ["patient"],
	components: {
		Breadcrumbs,
		NewAppointmentForm
	},
	data: () => ({}),
	computed: {
		items() {
			var appointmentsTab = "";
			if (this.$store.getters.hasRole("terapeut")) {
				appointmentsTab = "clinic";
			} else {
				appointmentsTab = "appointments";
			}
			const id = this.$route.params.pid;
			var items = [
				// {
				// 	text: this.$gettext("Patients"),
				// 	disabled: false,
				// 	link: true,
				// 	to: { name: "patients" }
				// },
				{
					name: true,
					text: this.patient.name,
					disabled: false,
					link: true,
					to: { name: "patient", params: { pid: id } }
				},
				{
					text: this.$gettext("Appointments"),
					disabled: false,
					link: true,
					to: {
						name: "patient",
						params: { pid: this.patient.id, tab: appointmentsTab }
					}
				},
				{
					text: this.$gettext("New"),
					disabled: true,
					link: true
				}
			];
			return items;
		}
	}
};
</script>